import { Input } from 'antd';
import { makePrioStyles } from '../../../theme/utils';
import { useTranslation } from 'react-i18next';
import { ChangeEvent, useEffect, useState } from 'react';
import { debounceFunction } from '../../../util';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const useStyles = makePrioStyles((theme) => ({
  search: {
    '&.ant-input-search > .ant-input-group > .ant-input-group-addon:last-child':
      {
        border: theme.old.borders.content,
        '& .ant-input-search-button': {
          height: '100%',
          background: 'transparent',
          padding: 0,
          width: 32,
          color: 'rgba(0, 0, 0, 0.6)',
          '&:hover': {
            background: 'transparent',
          },
        },
        '&:hover': {
          borderColor: 'var(--ant-primary-5)',
        },
      },
  },
}));

const debouncedChange = debounceFunction(
  (value: string, onChange: (value: string) => void) => {
    onChange(value);
  },
  500
);

interface ContactSearchInputFieldProps {
  id?: string;
  onChange: (value: string) => void;
  isOnline: boolean;
  value?: string;
}

const ContactSearchInputField = (props: ContactSearchInputFieldProps) => {
  //#region ------------------------------ Defaults
  const { id, onChange, isOnline, value } = props;

  const classes = useStyles();

  const { t } = useTranslation();
  //#endregion

  //#region ------------------------------ States / Attributes / Selectors
  const [currentValue, setCurrentValue] = useState<string>(value || '');
  //#endregion

  //#region ------------------------------ Methods / Handlers
  const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
    setCurrentValue(e.target.value);
    debouncedChange(e.target.value, onChange);
  };
  //#endregion

  //#region ------------------------------ Effects
  useEffect(() => {
    setCurrentValue(value || '');
  }, [value]);
  //#endregion

  return (
    <Input.Search
      allowClear
      size="middle"
      placeholder={t('contacts:contactSelectionList.search.placeHolder')}
      onChange={handleOnChange}
      className={classes.search}
      enterButton={isOnline && <FontAwesomeIcon icon={['fal', 'globe']} />}
      id={id}
      value={currentValue}
    />
  );
};

export default ContactSearchInputField;
